export default __webpack_public_path__ + "static/media/carousel5.20b38aeb.jpg";